import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmployeeCanDirective } from 'pm-src/app/directives/employee-can.directive';
import { HeaderModule } from '../header/header.module';
import { IonicModule } from '@ionic/angular';

import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [EmployeeCanDirective],
    imports: [TranslateModule, CommonModule, HeaderModule, IonicModule],
    exports: [HeaderModule, EmployeeCanDirective],
})
export class AppSharedModule {}
